"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin for management jobs API calls.
 */
var JobMixin = /** @class */ (function () {
    function JobMixin() {
    }
    /**
     * Management job creation
     * @param synopsis
     * @param type
     * @param address
     * @param city
     * @param state
     * @param latitude
     * @param longitude
     * @param dispatchGroupIds
     * @param typeId
     * @param incidentId
     * @param callback
     */
    JobMixin.prototype.createJob = function (synopsis, type, address, city, state, latitude, longitude, dispatchGroupIds, typeId, incidentId, callback) {
        var _this = this;
        var body = {
            synopsis: synopsis,
            type: models_1.JobTypeEnum[type],
            typeId: typeId,
            incidentId: incidentId,
            address: address,
            city: city,
            state: state,
            latitude: latitude,
            longitude: longitude,
            dispatchGroupIds: dispatchGroupIds,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post('/jobs', null, body, wrappedCallback);
    };
    JobMixin.prototype.getHeatmapParameters = function (start, end, agencyId, callback) {
        var _this = this;
        var startDate = start.toISOString();
        var endDate = end.toISOString();
        var params = { startDate: startDate, endDate: endDate, agencyId: agencyId };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.HeatmapParameters.parse, 'warn'));
        };
        this.http.post('/jobs/historical', params, wrappedCallback);
    };
    return JobMixin;
}());
exports.default = JobMixin;
//# sourceMappingURL=JobMixin.js.map